// site
export const VITE_SITE_TITLE = import.meta.env.VITE_SITE_TITLE;
export const VITE_DOMAIN = import.meta.env.VITE_DOMAIN;
export const VITE_BASEPATH = import.meta.env.VITE_BASEPATH;

// server
export const VITE_DATA_API = import.meta.env.VITE_DATA_API;
export const VITE_DATA_API_PREFIX = import.meta.env.VITE_DATA_API_PREFIX;

